import { AxiosInstance, AxiosRequestConfig } from 'axios';
import store from '@/store/index';

export interface UploadResponse {
  id: number;
  name: string;
  hash: string;
  ext: string;
  mime: string;
  size: number;
  path: string;
  merchant: string;
  updatedAt: Date;
  createdAt: Date;
}

export interface UploadFile {
  data: UploadResponse | null;
  id: number;
}


export class Upload {
  private readonly instance: AxiosInstance;
  // $store: any;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }


  public execute(file: Blob, merchant: string): Promise<UploadFile> {
    const URL = `/upload/${merchant}`;
    return new Promise((resolve, reject) => {
      // reject if token is empty
      if (!file) {
        reject({
          code: 'EMPTY_UPLOAD_PAYLOAD',
          message: 'File can not be empty'
        });
        return;
      }
      const formData = new FormData();
      // @ts-ignore: Unreachable code error
      formData.append('file', file.raw);
      const config: AxiosRequestConfig = {
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      };
      this.instance(URL, config)
        .then((res: any) => {
          resolve(res.data);
        })
        .catch((err) => {
          resolve(err);
        });
    });
  }
}
